const workflowIconUnitOffset = 25
const workflowIconBaseOffset = 16

export const workflowIconOffsets = {
  RECONCILED: workflowIconBaseOffset,
  NOTES: workflowIconBaseOffset + workflowIconUnitOffset,
  TODOS: workflowIconBaseOffset + workflowIconUnitOffset * 2 + 2,
  CHECKS: workflowIconBaseOffset + workflowIconUnitOffset * 3,
  REVIEW: workflowIconBaseOffset + workflowIconUnitOffset * 4,
  PROPOSAL: workflowIconBaseOffset + workflowIconUnitOffset * 5,
}

export const workflowProgressIconSelector = 'workflow-progress-icon'
